module.exports = __webpack_public_path__ + "img/join-us-banner.9d32e29a.png";